<div class="container d-flex justify-content-center mt-5">
  <div class="lds-ring"><div></div><div></div><div></div><div></div></div>
</div>